<template>
  <aside class="ks-left-drawer" :class="[leftDrawerClasses]">
    <div class="ks-left-drawer-backdrop" v-show="showBackdrop"></div>
    <div
      :class="{ 'left-drawer-width-full': screenSizeId > 3, 'left-drawer-width-mobile': screenSizeId <= 3, 'ks-left-drawer-menu': true }"
      style="position: relative"
    >
      <span
        style="cursor: pointer; position: absolute; z-index: 10; top: 5px; right: 20px"
        v-show="ksLeftDrawerConfig.showCloseIcon"
        @click.prevent="closeLeftDrawer"
      >
        <i class="fa fa-times" aria-hidden="true"></i>
      </span>
      <slot></slot>
    </div>
  </aside>
</template>

<script>
  import config from '@/config';

  export default {
    name: 'left_drawer',
    props: {
      screenSize: {
        type: String,
        required: true,
      },

      screenSizeId: {
        type: Number,
        required: true,
      },
    },
    watch: {
      /*'$route.path': function (path) {
      document.body.classList.remove(`ks-body-margin-left-drawer`);
    },*/
      ksLeftDrawerConfig: {
        handler: function (val) {
          this.changeLeftDrawerConfig();
        },
        deep: true,
      },
      screenSizeId: function (size, oldSize) {
        this.changeLeftDrawerConfig();
      },
    },
    computed: {
      leftDrawerClasses() {
        try {
          let CustomClasses =
            config.layout && config.layout.leftDrawer && config.layout.leftDrawer.classes && Array.isArray(config.layout.leftDrawer.classes)
              ? config.layout.leftDrawer.classes.join(' ')
              : '';
          return `${CustomClasses}`;
        } catch (err) {
          return '';
        }
      },
    },
    mounted() {
      /* Left Drawer  */
      this.ksLeftDrawer = document.querySelector('.ks-left-drawer');
      this.ksLeftDrawerBackdrop = document.querySelector('.ks-left-drawer-backdrop');
      this.ksLeftDrawerMenu = document.querySelector('.ks-left-drawer-menu');
      this.ksLeftDrawer.addEventListener('transitionend', this.OnTransitionLeftDrawerEnd, false);
      this.ksLeftDrawerBackdrop.addEventListener('click', this.toggleLeftDrawer, false);
      //add functions to global app var
      app.openLeftDrawer = this.openLeftDrawer;
      app.closeLeftDrawer = this.closeLeftDrawer;
      app.toggleLeftDrawer = this.toggleLeftDrawer;
      app.setLeftDrawerConfig = this.setLeftDrawerConfig;
      app.leftDrawerStatus = this.leftDrawerStatus;
    },
    methods: {
      setLeftDrawerConfig(config) {
        let aux = JSON.parse(JSON.stringify(this.ksLeftDrawerConfig));
        if (config !== null && typeof config == 'object') {
          aux.pushContent = config.pushContent != undefined ? config.pushContent : false;
          aux.showCloseIcon = config.showCloseIcon != undefined ? config.showCloseIcon : false;
          this.ksLeftDrawerConfig = aux;
        }
        this.leftDrawerStatus.pushContent = this.ksLeftDrawerConfig.pushContent;
        this.leftDrawerStatus.showCloseIcon = this.ksLeftDrawerConfig.showCloseIcon;
      },
      changeLeftDrawerConfig() {
        document.body.classList.remove(`ks-body-margin-left-drawer`);
        this.ksLeftDrawer.classList.remove(`ks-left-drawer-margin`);
        if (this.screenSizeId > 3) {
          if (this.ksLeftDrawerConfig.pushContent !== undefined && this.ksLeftDrawerConfig.pushContent === true) {
            if (this.leftDrawerStatus.isOpen) {
              document.body.classList.add(`ks-body-margin-left-drawer`);
              this.ksLeftDrawer.classList.add(`ks-left-drawer-margin`);
            }
            this.showBackdrop = false;
          }
        } else {
          this.showBackdrop = true;
        }
      },
      toggleLeftDrawer() {
        if (this.leftDrawerStatus.isOpen) {
          this.closeLeftDrawer();
        } else {
          this.openLeftDrawer();
        }
      },
      openLeftDrawer(config = null) {
        this.setLeftDrawerConfig(config);
        if (this.ksLeftDrawerConfig.pushContent && this.screenSizeId > 3) {
          document.body.classList.add(`ks-body-margin-left-drawer`);
          this.ksLeftDrawer.classList.add(`ks-left-drawer-margin`);
        }
        if (!this.ksLeftDrawer.classList.contains('ks-left-drawer--visible')) {
          this.ksLeftDrawer.classList.add('menu--animatable');
          this.ksLeftDrawer.classList.add('ks-left-drawer--visible');
        }
        this.leftDrawerStatus.isOpen = true;
      },
      closeLeftDrawer() {
        if (this.ksLeftDrawerConfig.pushContent) {
          document.body.classList.remove(`ks-body-margin-left-drawer`);
          this.ksLeftDrawer.classList.remove(`ks-left-drawer-margin`);
        }
        if (this.ksLeftDrawer.classList.contains('ks-left-drawer--visible')) {
          this.ksLeftDrawer.classList.add('menu--animatable');
          this.ksLeftDrawer.classList.remove('ks-left-drawer--visible');
        }
        this.leftDrawerStatus.isOpen = false;
      },
      OnTransitionLeftDrawerEnd() {
        this.ksLeftDrawer.classList.remove('menu--animatable');
      },
    },
    data() {
      return {
        ksLeftDrawer: {},
        ksLeftDrawerBackdrop: {},
        ksLeftDrawerMenu: {},
        showBackdrop: true,
        ksLeftDrawerConfig: {
          pushContent: false,
          showCloseIcon: true,
        },
        leftDrawerStatus: {
          isOpen: false,
          pushContent: false,
          showCloseIcon: true,
        },
      };
    },
  };
</script>

<style>
  /* Left Drawer classes */
  .ks-left-drawer {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    pointer-events: none;
    z-index: 110;
  }

  .ks-left-drawer--visible {
    pointer-events: none;
  }

  .left-drawer-width-full {
    max-width: 400px;
  }

  .left-drawer-width-mobile {
    max-width: 85%;
  }

  .ks-left-drawer-menu {
    background-color: #fff;
    position: relative;
    width: 100%;
    height: 100%;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
    -webkit-transform: translateX(-103%);
    transform: translateX(-103%);
    display: flex;
    flex-direction: column;
    will-change: transform;
    z-index: 160;
    pointer-events: auto;
    overflow: hidden;
  }

  .ks-left-drawer--visible .ks-left-drawer-menu {
    -webkit-transform: none;
    transform: none;
  }

  .ks-left-drawer--animatable .ks-left-drawer-menu {
    transition: all 130ms ease-in;
  }

  .ks-left-drawer--visible.ks-left-drawer--animatable .ks-left-drawer-menu {
    transition: all 330ms ease-out;
  }

  .ks-left-drawer-backdrop {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    opacity: 0;
    will-change: opacity;
    pointer-events: none;
    transition: opacity 0.3s cubic-bezier(0, 0, 0.3, 1);
  }

  .ks-left-drawer--visible .ks-left-drawer-backdrop {
    opacity: 1;
    pointer-events: auto;
  }

  .ks-body-margin-left-drawer {
    margin-left: 400px;
  }

  .ks-left-drawer-margin {
    margin-top: 55px;
  }
</style>
